import { GET_IX_GRADES } from "./actionTypes";

// eslint-disable-next-line 
export default (state = {}, action) => {
  switch(action.type) {
    case GET_IX_GRADES:
      const { courseOfferingId, data, error, loading } = action.payload;
      return {
        ...state,
        [courseOfferingId]: {
          data: data || null,
          error: error || null,
          loading: loading || false
        }
      };
    default:
      return state;  
  }
};
